<style scoped lang="less">
  .task-replay {
    position: relative;
    padding-left: 20px;
    &::before {
        z-index: 1;
        left: -6px;
        top: 15px;
        color: #657180;
        font-family: 'iconfont';
        position: absolute;
        content: '\e609';
        display: block;
    }
  }
</style>

<style lang="less">
  .task-replay {
    .fm-input-new.fm-textarea {
      &::before {
        transform: rotate(-45deg);
        position: absolute;
        top: 16px;
        content: '';
        left: -5px;
        display: block;
        width: 8px;
        height: 8px;
        border: 1px solid #EEE;
        border-right: none;
        border-bottom: none;
        background-color: #FFF;
        z-index: 1;
      }
    }
  }
</style>

<template>
  <div class="task-replay">
    <fm-input-new style="display: flex;" type="textarea" v-model="content" placeholder="在此输入评论内容"></fm-input-new>
    <fm-btn style="margin-top: 10px;" type="primary" v-loadingx="loading" @click="submit">发表</fm-btn>
  </div>
</template>

<script>
import { taskReplyRequest } from '@/api'
export default {
  props: {
    taskId: {
      type: Number,
      default: null
    },
    replyUserId: {
      type: Number,
      default: null
    },
    repliedTaskReplyId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      content: null,
      loading: false
    }
  },
  methods: {
    async submit () {
      if (!this.content) {
        this.$notice.warning('请输入评论内容')
      } else {
        this.loading = true
        await taskReplyRequest.add({
          taskId: this.taskId,
          content: this.content,
          repliedTaskReplyId: this.repliedTaskReplyId,
          replyUserId: this.$store.getters.userInfo.id
        })
        this.$emit('add-replay')
        this.content = null
        this.loading = false
      }
    }
  }
}
</script>
